import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DateTime } from "luxon";
import DaysTable from "./DaysTable";
import {
  updateStartDate,
  updateNumberOfDays,
} from "../../stores/schedule/scheduleActions";

const Schedule = (props) => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.member.loading);
  const shifts = useSelector((state) => state.member.shifts);
  const schedule = useSelector((state) => state.schedule.schedule);

  useEffect(() => {
    window.exitWarningDirty = false;
    dispatch(updateStartDate(props.event.startingAt || DateTime.now()));
  }, [props.event.startingAt, dispatch]);

  useEffect(() => {
    document
      .getElementById("schedule-edit")
      .dispatchEvent(new Event("updated"));
  });

  useEffect(() => {
    const setNumberOfDays = () => {
      const width = window.innerWidth;
      let number_of_days;
      if (width < 992) {
        number_of_days = 4;
      } else if (width < 1200) {
        number_of_days = 5;
      } else {
        number_of_days = 7;
      }
      dispatch(updateNumberOfDays(number_of_days));
    };

    window.addEventListener("resize", setNumberOfDays);
    setNumberOfDays();

    return () => {
      window.removeEventListener("resize", setNumberOfDays);
    };
  }, [dispatch]);

  if (!loading) {
    return (
      <DaysTable
        shifts={shifts}
        event={props.event}
        start_date={schedule.start_date}
        num_days={schedule.number_of_days}
        memberTypeProperties={props.memberTypeProperties}
        readOnly={props.readOnly}
        canSkipValidation={props.canSkipValidation}
      />
    );
  } else {
    return (
      <div className="loading_container">
        <i className="fa fa-spinner fa-spin"></i>
      </div>
    );
  }
};

export default Schedule;
